varying highp vec2 v_texturecoord;

uniform vec2 u_resolution;
uniform float u_time;
uniform sampler2D u_sampler;
uniform sampler2D u_windowsTex;
uniform float u_damage;
uniform float u_music_volume;
uniform float u_deathtransition;


float rand(vec2 n) { 
	return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
}

vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }

float snoise(vec2 v){
  const vec4 C = vec4(0.211324865405187, 0.366025403784439,
           -0.577350269189626, 0.024390243902439);
  vec2 i  = floor(v + dot(v, C.yy) );
  vec2 x0 = v -   i + dot(i, C.xx);
  vec2 i1;
  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod(i, 289.0);
  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
  + i.x + vec3(0.0, i1.x, 1.0 ));
  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),
    dot(x12.zw,x12.zw)), 0.0);
  m = m*m ;
  m = m*m ;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
  vec3 g;
  g.x  = a0.x  * x0.x  + h.x  * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}

float czm_luminance(vec3 rgb)
{
    // Algorithm from Chapter 10 of Graphics Shaders.
    const vec3 W = vec3(0.2125, 0.7154, 0.0721);
    return dot(rgb, W);
}

vec2 uvglitch(vec2 uv, float offset){
  vec2 guv = uv;
  guv.x += snoise(vec2(floor(u_time * 10. + uv.y * 10. + offset))) * 0.01 * u_damage;
  guv.y += snoise(vec2(floor(u_time * 10. + uv.x * 10. + 1000. + offset))) * 0.01 * u_damage;
  return guv;
}

vec4 chromaticAberation(vec2 uv, sampler2D tex){
  vec2 dir = (uv - 0.5) * vec2(1.0, 1.0);
  float radius = length(dir);

  float aberation = 0.2 * u_music_volume;

  vec2 uvR = fract((uvglitch(uv,0.) - dir * radius * aberation * 1.2 - 0.5) + 0.5);
  vec2 uvG = fract((uvglitch(uv,10.) - dir * radius * aberation * 1.1 - 0.5) + 0.5);
  vec2 uvB = fract((uvglitch(uv,20.) - dir * radius * aberation - 0.5) + 0.5);

  vec4 R = texture2D(tex, uvR);
  vec4 G = texture2D(tex, uvG);
  vec4 B = texture2D(tex, uvB);

  vec4 color = vec4(R.r,G.g,B.b,R.a + B.a + G.a);
  return color;
}

void main(void) {
  vec2 pixel = (gl_FragCoord.xy / u_resolution.x);
  vec2 ratio = vec2(1. ,u_resolution.y / u_resolution.x);
  vec2 uv = v_texturecoord;
  uv.y = 1. - uv.y;

  float vibrato = 5.; 
  float shake = 0.01;
  uv += vec2(snoise(vec2(u_time) * vibrato), snoise(vec2(u_time + 1000.) * vibrato)) * shake * u_damage;

  vec4 chroma = chromaticAberation(uv, u_sampler);

  float noise = rand(fract(uv + u_time));
  float rnoise = noise * 0.1 + noise * czm_luminance(chroma.rgb) * 0.9;

  vec4 windows = chromaticAberation(v_texturecoord, u_windowsTex);
  float wnoise = noise * 0.01 + noise * czm_luminance(windows.rgb) * 0.5;

  vec4 render = chroma + rnoise;
  vec4 final = mix(render, windows + wnoise, u_deathtransition);

  gl_FragColor = final;
}
